<template>
    <u-dialog-underline-rounded v-model="shows" v-bind="$attrs">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-dialog-underline-rounded>
</template>

<script>
import UDialogUnderlineRounded from "@/components/publish/styles/dialogs/u-dialog-underline-rounded.vue";

export default {
    props: {},
    components: {
        UDialogUnderlineRounded,
    },
    data() {
        return {
            shows: false,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
